export let useApplyTemplate = false;

export const setApplyTemplate = (val) => {
    useApplyTemplate = val
}